// Angular
import { Component, Inject, OnInit, ChangeDetectionStrategy, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { KeyValue } from '@angular/common';

// Libraries
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Models
import { AppCleanup } from '../../../../shared/models';
import { GenerateJobLinkPayload, Job } from '../../models';
import { ChannelConfigPayload } from '../../../channel/models';

// Services
import { JobService } from '../../services/job.service';

export interface NewJobLinkData {
	name?: string;
	job: Job;
}

export interface ExpireDaysOption extends KeyValue<number, string> {}

@Component({
	selector: 'new-job-link-dialog',
	templateUrl: './new-job-link-dialog.component.html',
	styleUrls: ['new-job-link-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewJobLinkDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	form: FormGroup;
	expireDaysOptions = [
		<ExpireDaysOption>{ key: 1, value: '1 Day' },
		<ExpireDaysOption>{ key: 2, value: '2 Days' },
		<ExpireDaysOption>{ key: 3, value: '3 Days' },
		<ExpireDaysOption>{ key: 4, value: '4 Days' },
		<ExpireDaysOption>{ key: 5, value: '5 Days' },
		<ExpireDaysOption>{ key: 6, value: '6 Days' },
		<ExpireDaysOption>{ key: 7, value: '7 Days' },
		<ExpireDaysOption>{ key: 0, value: 'Never' }
	];
	jobLinkUrl: string;

	constructor(
		formBuilder: FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: NewJobLinkData,
		public dialogRef: MatDialogRef<NewJobLinkDialogComponent>,
		public jobService: JobService
	) {
		super();
		let root = window.location.origin;
		this.jobLinkUrl = `${root}/job/link`;
		this.form = formBuilder.group({
			comments: [null],
			expireDays: [0, [Validators.required]],
		});
	}

	ngOnInit() {}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	submit() {
		let allChannels = [];
		for (let i = 0; i < this.data.job.unitPeriods.length; i++) {
			let channels = this.jobService.findUserUnitPeriodChannels(this.data.job.key, this.data.job.unitPeriods[i]?.id).map(
				(c, i) =>
					<ChannelConfigPayload>{
						channelId: c.unitPeriodChannel.channelId,
						order: i,
						colorHex: c.colorHex,
						visible: c.display,
						visibleGraph: c.showGraph,
						lineStyle: c.lineStyle,
						lineWeight: c.lineWeight,
						unitPeriodId: this.data.job.unitPeriods[0]?.id,
						minY: c.minY,
						maxY: c.maxY,
					}
			);

			allChannels.push(...channels);
		}

		let payload: GenerateJobLinkPayload = Object.assign(
			<GenerateJobLinkPayload>{
				key: this.data.job.key,
				channels: allChannels,
			},
			this.form.value
		);

		this.dialogRef.close(payload);
	}
}
